/* loaded by smart-asset */
export default require("./assets/blue-tote.i.svg")